/**
 * The reader's channel focus (UX-SPEC §6.2, UD-8): at most 3 channels, each with its own colour and line style
 * (slot 1 solid `--cat-1`, slot 2 dashed `--cat-2`, slot 3 dotted `--cat-3`). A fourth choice replaces the oldest.
 * The channel list, hotspot rows and the reader toolbar all write here; the reader mirrors it into the route (`ch=`).
 */
import { signal } from '@preact/signals';
import type { ChannelId } from '../engine/channels/types.ts';

export const FOCUS_CAP = 3;

export const focus = signal<ChannelId[]>([]);
/** Set when a choice replaced the oldest; the UI shows the notice once and clears it. */
export const focusReplaced = signal(false);

export function setFocus(ids: readonly ChannelId[]): void {
	const unique = [...new Set(ids)];
	focus.value = unique.slice(-FOCUS_CAP);
}

export function addFocus(id: ChannelId): void {
	const cur = focus.value.filter((x) => x !== id);
	if (cur.length >= FOCUS_CAP) focusReplaced.value = true;
	focus.value = [...cur, id].slice(-FOCUS_CAP);
}

export function removeFocus(id: ChannelId): void {
	focus.value = focus.value.filter((x) => x !== id);
}

export function toggleFocus(id: ChannelId): void {
	if (focus.value.includes(id)) removeFocus(id);
	else addFocus(id);
}

export function clearFocus(): void {
	focus.value = [];
	focusReplaced.value = false;
}
